export default "__VITE_ASSET__B0hGCyjN__"